import React, { useState, useEffect } from "react";

// import { useUsersByRole } from "../../../data/user";
import { useUsersByRole } from "../../../../data/user";

const SelectorByRole = ({
  value,
  setValue,
  role,
  name,
  display,
  placeholder,
  directions,
  readOnly = false,
}) => {
  const {
    data: lookupData = {},
    status: lookupStatus = "",
    error: lookupError,
  } = useUsersByRole(role);

  const handleChange = (event) => {
    setValue(event.target.value);
    console.log("event.target.value",event.target.value);
    event.preventDefault();
  };

  return (
    <div key={name} id={name} className="relative">
      <label className="text-instant-teams-teal-Main text-sm  absolute  duration-300 transform -translate-y-4 scale-75 top-4 origin-[0] left-2.5 peer-focus:text-instant-teams-blue-Main peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">
        {display} {directions ? " - " + directions : null}
        {readOnly ? " - LOCKED" : null}
      </label>
      <select
        name={name}
        value={value}
        onChange={handleChange}
        className="form-input shadow-md rounded-md w-full pt-3"
        disabled={readOnly}
      >
        <option value="" defaultValue={""}>
          {placeholder}
        </option>
        {Object.keys(lookupData).length ? (
          lookupData.map((key) => (
            <option key={key.id} value={key.id}>
              {key.preferredName}
            </option>
          ))
        ) : (
          <option disabled={true}>N/A</option>
        )}
      </select>
    </div>
  );
};

export default SelectorByRole;
